import { ShoppingCartSummaryDto, ShoppingCartSummaryBundleDto, ShoppingCartSummaryPriceDto } from "@/api/models/shoppingCart.model";

interface ShoppingCartState {
	shoppingCartId: string;
	shoppingCartLoading: boolean;
	summary: ShoppingCartSummaryDto;
}

export const shoppingCartInitialState = () => {
	return {
		shoppingCartId: "",
		shoppingCartLoading: false,

		summary: {
			bundles: [] as ShoppingCartSummaryBundleDto[],
			prices: [] as ShoppingCartSummaryPriceDto[]
		}
	};
};

const state: ShoppingCartState = shoppingCartInitialState();
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

export default {
	state,
	actions,
	mutations,
	getters
};
